/**
 * End-to-end hotel price audit (console only).
 * Enable: localStorage.setItem('HOTEL_PRICE_TRACE', '1')
 */

export function isHotelPriceTraceEnabled() {
  try {
    return (
      typeof window !== "undefined" &&
      window.localStorage?.getItem("HOTEL_PRICE_TRACE") === "1"
    );
  } catch {
    return false;
  }
}

/**
 * @param {string} stage
 * @param {Record<string, unknown>} payload
 */
/** לוג תיקון תצוגת מחיר מלון (מחיר שכבר ILS). */
export function logHotelPriceFix(payload) {
  if (!isHotelPriceTraceEnabled()) return;
  try {
    console.info("[HOTEL_PRICE_FIX]", payload);
  } catch {
    /* ignore */
  }
}

export function logHotelPriceTrace(stage, payload) {
  if (!isHotelPriceTraceEnabled()) return;
  try {
    let currentRate = null;
    try {
      const r = window.localStorage?.getItem("currentRate");
      if (r && r !== "undefined") currentRate = parseFloat(r);
    } catch {
      /* ignore */
    }
    console.info("[HOTEL_PRICE_TRACE]", stage, {
      t: new Date().toISOString(),
      localStorageCurrentRate: Number.isFinite(currentRate) ? currentRate : null,
      ...payload,
    });
  } catch {
    /* ignore */
  }
}

/** לוג מחיר חדר בפרופיל מלון (אותו דגל כמו HOTEL_PRICE_TRACE). */
export function logRoomPriceTrace(payload) {
  if (!isHotelPriceTraceEnabled()) return;
  try {
    console.info("[ROOM_PRICE_TRACE]", {
      t: new Date().toISOString(),
      ...payload,
    });
  } catch {
    /* ignore */
  }
}

/** השוואת שדות API מול ערכי תצוגה (אותו דגל HOTEL_PRICE_TRACE). */
export function logRoomPriceSourceAudit(payload) {
  if (!isHotelPriceTraceEnabled()) return;
  try {
    console.info("[ROOM_PRICE_SOURCE_AUDIT]", {
      t: new Date().toISOString(),
      ...payload,
    });
  } catch {
    /* ignore */
  }
}

/**
 * לינות / חדרים / מבוגרים מתוך searchPhrase (DD/MM/YYYY).
 * @param {object|null|undefined} phrase
 */
export function getStayMetaFromSearchPhrase(phrase) {
  try {
    const rooms = phrase?.rooms;
    if (!Array.isArray(rooms) || !phrase?.checkIn || !phrase?.checkOut) {
      return { nights: null, roomCount: null, adults: null };
    }
    let adults = 0;
    rooms.forEach((r) => {
      adults += Number(r?.AdultsCount) || 0;
    });
    const cin = String(phrase.checkIn).split("/");
    const cout = String(phrase.checkOut).split("/");
    if (cin.length < 3 || cout.length < 3) {
      return { nights: null, roomCount: rooms.length, adults };
    }
    const d1 = new Date(Number(cin[2]), Number(cin[1]) - 1, Number(cin[0]));
    const d2 = new Date(Number(cout[2]), Number(cout[1]) - 1, Number(cout[0]));
    const nights = Math.floor((d2 - d1) / 86400000);
    return {
      nights: nights >= 0 ? nights : null,
      roomCount: rooms.length,
      adults,
    };
  } catch {
    return { nights: null, roomCount: null, adults: null };
  }
}
